<template>
    <!-- Shared gauge-bar rendering for the Active groups table's index columns (Growth Index,
         Water Index): a fixed-width track with a centre "on target" marker, filled per the unified
         index colour scheme, plus the numeric value. Purely presentational - the surrounding cell
         owns the sensor gate, clickability and click handler. -->
    <div class="relative h-[5px] w-[74px] shrink-0 rounded-full bg-[#EEF1F4]">
        <div class="absolute left-0 top-0 h-full rounded-full transition-all" :class="indexBgColourClass(value)" :style="{ width: gaugeWidth(value) }" />
        <div class="absolute top-0 h-full w-px bg-[#9AA8B5]" style="left: 50%" />
    </div>
    <span class="tabular-nums text-[12.5px] font-bold text-gray-900">{{ value }}</span>
</template>

<script setup lang="ts">
import { indexBgColourClass } from './indexColour';

defineProps<{
    // The index value (0 → 0% filled, 100 → 50% filled/on target, 200+ → 100% filled).
    value: number;
}>();

// Maps 0 → 0%, 100 → 50%, 200+ → 100% so the centre marker always sits at "on target".
// Clamped at both ends: the live Growth Index is a day-over-day derivation and goes non-physically
// negative when a section is restocked mid-Production Group (observed: -1334), which would otherwise
// produce a negative CSS width. The numeric value beside the bar is still printed as delivered —
// the bar is clamped, the figure is never hidden.
function gaugeWidth(value: number): string {
    return `${Math.min(100, Math.max(0, value / 2))}%`;
}
</script>
